module.exports = __webpack_public_path__ + "static/media/android-badge-white.0b672673.png";